<template>
    <div>
        <app-contratacoes
            :contratacoes="contratacoes"
            :contratacoesServicos="obterServicos()"
            @obterAtualizacao="obterContratacoes()"
            titulo="GESTORES DESIGNADOS"
            v-show="mostrarContratacoes"
        >
            <!-- <template slot="botoes"> </template>
            <template slot="acoes" slot-scope="data">
                <span
                    class="text-primary"
                    v-if="$temAcessoView('CRED-GER-CONT-01')"
                >
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Detalhar"
                        @click.stop="detalharContratacao(data.codContratacao)"
                    ></i>
                </span>
            </template> -->
        </app-contratacoes>
        <router-view></router-view>
    </div>
</template>

<script>
import GestoresDesignadosServicos from './GestoresDesignadosServicos'
import Contratacoes from '@/app/credenciados/componentes/contratacoes/Contratacoes2'

export default {
    data() {
        return {
            contratacoes: []
        }
    },

    methods: {
        obterContratacoes() {
            this.$store.dispatch('addRequest')
            GestoresDesignadosServicos.obterContratacoes().then(response => {
                if (response) {
                    if (response.success) {
                        this.contratacoes = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterServicos() {
            return GestoresDesignadosServicos
        }

        // detalharContratacao(id) {
        //     this.$router.push({
        //         name: `Gerentes_Contratacoes_Detalhar`,
        //         params: {
        //             contratacaoId: id
        //         }
        //     })
        // }
    },

    created() {
        this.obterContratacoes()
    },

    computed: {
        mostrarContratacoes() {
            return this.$route.name === 'Gerentes_GestoresDesignados'
        }
    },

    watch: {
        $route(to) {
            if (to.name === 'Gerentes_GestoresDesignados') {
                if (this.$store.getters.recarregar) {
                    this.obterContratacoes()
                    this.$store.dispatch('setRecarregar', false)
                }
            }
        }
    },

    components: {
        AppContratacoes: Contratacoes
    }
}
</script>
